// Format date to dd/mm/yyyy
const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const [year, month, day] = dateStr.split("-");
  return `${day}/${month}/${year}`;
};

// utils/timeService.js

/**
 * Calculate time left until closing (end date + end time)
 * @param {string} todate - end date in YYYY-MM-DD format
 * @param {string} [endtime] - optional end time in HH:mm:ss format
 * @returns {string|null} formatted string of remaining time or "Closed"
 */
const getClosingTime = (todate, endtime) => {
  if (!todate) return null;

  // build full Date
  const endDate = new Date(todate + (endtime ? `T${endtime}` : "T23:59:59"));
  const now = new Date();

  const diffMs = endDate - now;
  if (diffMs <= 0) return "Closed";

  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const diffHours = Math.floor((diffMs / (1000 * 60 * 60)) % 24);
  const diffMins = Math.floor((diffMs / (1000 * 60)) % 60);

  return `Closing in ${diffDays} Days ${diffHours} Hours ${diffMins} Mins`;
};

const weekDaysList = [
  { id: "1", label: "M", value: "monday" },
  { id: "2", label: "T", value: "tuesday" },
  { id: "3", label: "W", value: "wednesday" },
  { id: "4", label: "T", value: "thursday" },
  { id: "5", label: "F", value: "friday" },
  { id: "6", label: "S", value: "saturday" },
  { id: "7", label: "S", value: "sunday" },
];

/**
 * Get all dates between start and end date that match given weekdays.
 * @param {string} startDate - format: 'YYYY-MM-DD'
 * @param {string} endDate - format: 'YYYY-MM-DD'
 * @param {string[]} usageDaysOfweek - array of weekday names, e.g. ['wednesday','saturday']
 * @returns {string[]} - array of dates in 'YYYY-MM-DD' format
 */
const getMatchingDates = (startDate, endDate, usageDaysOfweek) => {
  // console.log("getMatchingDates", startDate, endDate, usageDaysOfweek);
  if (
    !startDate ||
    !endDate ||
    !usageDaysOfweek ||
    usageDaysOfweek.length === 0
  ) {
    return [];
  }
  const result = [];
  const start = new Date(startDate);
  const end = new Date(endDate);

  // Map JS getDay() (0=Sunday, ..., 6=Saturday) to weekday names
  const dayNames = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ];

  for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
    const dayName = dayNames[d.getDay()];
    if (usageDaysOfweek.includes(dayName)) {
      // Format as YYYY-MM-DD
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      result.push(`${yyyy}-${mm}-${dd}`);
    }
  }
  return result;
};

const convertTo24Hour = (time12h) => {
  if (!time12h) return "";
  const [time, modifier] = time12h.split(" ");
  let [hours, minutes] = time.split(":");
  if (modifier === "PM" && hours !== "12") {
    hours = String(Number(hours) + 12);
  }
  if (modifier === "AM" && hours === "12") {
    hours = "00";
  }
  return `${hours.padStart(2, "0")}:${minutes}`;
};

function to12HourFormat(time24) {
  if (!time24) return "";
  let [hour, minute] = time24.split(":");
  let h = parseInt(hour, 10);
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${h.toString().padStart(2, "0")}:${minute} ${ampm}`;
}

// Helper: Convert "08:02 PM" or "10:00" to "HH:mm"
function normalizeTime(timeStr) {
  if (!timeStr) return "";
  // If already 24-hour format (no AM/PM)
  if (/^\d{2}:\d{2}$/.test(timeStr)) {
    return timeStr;
  }
  // If 12-hour format with AM/PM
  const [time, modifier] = timeStr.split(" ");
  if (!modifier) return timeStr; // fallback
  let [hours, minutes] = time.split(":");
  if (modifier === "PM" && hours !== "12") {
    hours = String(Number(hours) + 12);
  }
  if (modifier === "AM" && hours === "12") {
    hours = "00";
  }
  return `${hours.padStart(2, "0")}:${minutes}`;
}

export {
  formatDate,
  getClosingTime,
  weekDaysList,
  getMatchingDates,
  convertTo24Hour,
  to12HourFormat,
  normalizeTime,
};
